<!--
 * @Description  : 乘车人信息卡片
-->
<template minapp='mpx' xlang='wxml'>
  <view>
    <view wx:for="{{passengerList}}" class="passenger card-flex-wrap">
      <!-- <view
        class="passenger-checkbox"
        bindtap="selectPassengerCheckbox(item.id, (!item.passenger_name || !item.id_no))">
        <es-checkbox
          value="{{curPassengerIndexList}}"
          name="{{item.id}}"
          iconSize="{{18}}"
          iconStyle="{{checkboxIconWrapStyle}}"
          disabled="{{!item.passenger_name || !item.id_no}}"
          useIconSlot>
          <es-icon slot="icon" size="12" name="check-filled" wx:style="{{checkboxIconStyle}}"/>
        </es-checkbox>
      </view> -->
      <view
        class="card-flex-wrap passenger-btn"
        bindtap="selectPassenger(index)"
      >
        <view class="passenger-middle">
          <view class="passenger-name">{{ item.passenger_name }}</view>
          <view class="passenger-type">{{ getPassengerType(item.passenger_type) }}</view>
          <view class="passenger-number"
            >{{ item.encrypt_id_no }}</view
          >
        </view>
        <es-icon
          wx:if="{{showArrow}}"
          class="link-btn-icon display-inline-block"
          size="18"
          name="angle-right"
        />
      </view>
      <image
        class="passenger-del"
        src="https://ut-static.udache.com/webx/sfc/suxvGlrGntfJ94ro0mihR.png"
        bindtap="deletePassenger(item.id)"
      />
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  // 出行人选择页面数据回传 1.引入contact子包中的store，⚠️注意不要与主包中store名冲突
  import store from '@/store'
  import { AES_ECB_ENCRYPT_BY_KEY } from '@/common/crypto'
  createComponent({
    props: {
      showArrow: Boolean,
      passengerList: [],
    },
    data() {
      return {
        curPassengerIndexList: [],
        checkboxIconWrapStyle: {
          'border-radius': '6px',
          'align-self': 'normal',
        },
        checkboxIconStyle: {
          width: '18px',
        },
        category: 'train',
      }
    },
    computed: {
      ...store.mapState({
        selectedContacts: 'newContacts.selectedContacts'
      }),
    },
    // 3.更新travelerRuleDetail对象
    watch: {
      //选择出行人数据数据回传
      selectedContacts: {
        immediate: true,
        handler(data) {
          let curArr3 = []
          data?.map?.((item, index) => {
            // 出行人证件信息完整,才能被默认选中
            item?.id && curArr3.push(item.id)
          })
          this.curPassengerIndexList = curArr3
          this.$trigger('select', this.curPassengerIndexList)
          this.$trigger('list', data)
        },
      },
    },
    methods: {
      selectPassengerCheckbox(passengerId, isDisabled) {
        if (isDisabled) {
          // 当前乘机人信息不完整,不可勾选
          return
        }
        let curArr = [...this.curPassengerIndexList]
        if (curArr.includes(passengerId)) {
          curArr = curArr.filter(item => item !== passengerId)
        } else {
          curArr.push(passengerId)
        }
        this.curPassengerIndexList = curArr
        this.$trigger('select', this.curPassengerIndexList)
      },
      deletePassenger(passengerId) {
        let curArr = [...this.curPassengerIndexList]
        curArr = curArr.filter(item => item !== passengerId)
        this.curPassengerIndexList = curArr
        this.$trigger('select', this.curPassengerIndexList)
        const newPassengerList = this.passengerList.filter(item => item.id !== passengerId)
        this.$trigger('list',newPassengerList)
      },
      //验证出行人信息是否缺失
      isMissing(data, config) {
        let configKey = Object.keys(config || {})
        let isCardExpiredShow =
          config?.expire_date?.isRequired ||
          config?.expire_date?.requiredcCrdTypes?.includes(
            '' + data?.card_list?.[0]?.card_type
          ) > 0

        //1、证件:无证件号 或 有证件号 但是需要填写有效期 且有效期为空 则缺失
        //2、国际业务中: 英文姓名、手机号、出生日期、性别、国际必填
        //3、国内业务中: 中文名、手机号必填
        let isCardMissing =
          !data.card_list?.[0]?.card_no ||
          (isCardExpiredShow && data.card_list?.[0]?.expire_date === '')

        let isOtherMissing = false
        configKey.map(item => {
          if (
            config[item] &&
            (data[item] === '' || data[item] === '0') &&
            item !== 'nationlity' &&
            (config[item].isRequired ||
              config[item].requiredcCrdTypes?.includes(
                '' + data.card_list?.[0]?.card_type
              ) > 0)
          ) {
            isOtherMissing = true
            //如果是不需要证件的时候,名字必填，不计入，后面另外判断
            //因为已经过滤了contact_phone，所以排除改检验
            if ('contact_phone' === item) {
              isOtherMissing = false
            }
          }
          if (
            config[item] &&
            item === 'nationlity' &&
            data.canonical_country_code === '' &&
            (config[item].isRequired ||
              config[item].requiredcCrdTypes?.includes(
                '' + data.card_list?.[0]?.card_type
              ) > 0)
          ) {
            isOtherMissing = true
          }
        })
        return isCardMissing || isOtherMissing
      },

      selectPassenger(selectPassengerIndex) {
        if (!this.showArrow) {
          return
        }
        const {
          id: userId,
          card_list,
          sub_type,
          is_tmp_traveler,
          is_my_tmp_traveler,
        } = this.passengerList[selectPassengerIndex]
        // 跳转到对应的乘机人/出行人编辑页
        const curData = {
          category: this.category, //品类 flight hotel train
          userId, // 出行人ID
          card_type: card_list?.[0] ? card_list?.[0]?.card_type : '', // 出行人证件类型
          need_card: 1, // 接口返回是否需要证件信息
          source: 2, // 页面来源，从哪个入口进入,1：常用联系人列表（默认值，不填写该字段时默认为常用联系人）,2：选择出行人列表
          scene: 1, //场景 1因公 2因私
          need_approval: 1, // 是否需要审批 // need_approval流程类型 1: 需要差旅单流程; 2: 无需差旅单流程
          sub_type: sub_type, // 出行人类型 1：员工 2：公司维护外部出行人 3：个人维护外部出行人 4：个人因私出行人（默认值）
        }
        // 是否需要审批 // need_approval流程类型 1: 需要差旅单流程; 2: 无需差旅单流程
        // 跳转乘机人列表前,暂存当前选择的单个乘机人,用于返回本页时替换
        this.editPassengerIndex = String(selectPassengerIndex)

        //如果是临时外部出行人
        if (is_tmp_traveler) {
          curData.is_tmp_traveler = is_tmp_traveler
          curData.is_my_tmp_traveler = is_my_tmp_traveler
        }
        //先这样写 代订优化此处交互 以及校验逻辑
        this.$trigger('editPassenger', true)
        innerRouter.push('/contact/pages/edit', curData)
      },
      getPassengerType(type) {
        if(+type === 0) return '成人票'
        else if(+type === 1) return '儿童票'
        else if(+type === 2) return '学生票'
      }
    },
  })
</script>
<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

.card-flex-wrap
  padding 0 12px
  display flex
  justify-content space-between
  font-size 14px
  .flex-left, .flex-right
    display flex
    align-items center
.passenger
  padding 16px 4px 16px 0px !important
  box-sizing border-box
  justify-content space-between
  align-items center
  border-bottom 0.5px solid #D1DBE9
  &:first-child
    border-radius 8px 8px 0 0
  &-btn
    flex 1
    justify-content flex-end
    align-items center
    padding 0
  &-middle
    flex 1
    display flex
    align-items center
  &-type
    font-size 10px
    line-height 10px
    color #999999
    margin-right 16px
    padding 2px
    font-family PingFangSC-Regular
    position relative
    &:after
      position absolute
      content: ""
      width 200%
      height 200%
      border 1px solid #ccc
      transform-origin: 0 0
      transform: scale(0.5)
      border-radius 6px
      top 0
      left 0
  &-name
    font-family PingFangSC-Medium
    font-size 16px
    line-height 16px
    color #000
    font-weight normal
    margin-right 4px
  &-number
    font-family PingFangSC-Regular
    font-size 16px
    line-height 16px
    color #666
  &-add
    width 100%
    background-color #edf4ff
    border-radius 8px
    margin 0 auto
    font-size 14px
    line-height 44px
    text-align center
    color $train-color-theme-blue
    &-icon
      display inline-block
      margin-right 4px
      vertical-align bottom
    &-text
      font-weight 700
  &-del
    height 15px
    width 15px
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-checkbox': '@/es-mpx-ui/lib/checkbox',
    },
  }
</script>